// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2O3jx","icon":"SortAdornment_icon__2vh4D","up":"SortAdornment_up__2biOq","down":"SortAdornment_down__3DsXV","active":"SortAdornment_active__2OTq4"};